<template>
    <div>
        <h1 class="display-heading">Patient List</h1>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col width="250">
                    <col>
                    <col>
                    <col width="100">
                    <col width="100">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Join Date</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email Address</th>
                            <th scope="col">Type</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="userList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(user, index) in userList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>{{user.joinedDate}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.email}}</td>
                            <td>
                                <span v-if="user.isCorporateUser" class="badge text-nowrap badge-primary">
                                    Corporate
                                </span>
                                <span v-else class="badge text-nowrap badge-success">
                                    Public
                                </span>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'admin-view-patient',
                                    'params': {'id': user.userId}
                                }">
                                View User
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'PatientList',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getPatients();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'userList': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPatients();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getPatients () {
            this.axios.post('user/GetUsers', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.userList = list.map((user) => ({
                    'name': user.f ? user.f : '-',
                    'email': user.e ? user.e : '-',
                    'joinedDate': user.jd ? convertToUserReadableDateTime(user.jd) : '-',
                    'isCorporateUser': !!user.ci,
                    'userId': user.i
                }));
            });
        }
    }
};

</script>

<style>

</style>
